import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { OnboardingCard } from './OnboardingCard';
import { Package } from 'lucide-react';

interface OnboardingSession {
  id: string;
  status: string;
  created_at: string;
}

interface OnboardingItem {
  id: string;
  status: string;
  catalog_id: string | null;
  deal_id: string | null;
  eligibility: any;
  catalog?: {
    name: string;
    description: string | null;
  } | null;
  deal?: {
    id: string;
    deal_name: string | null;
    contacts?: {
      id: string;
      first_name: string | null;
      last_name: string | null;
    } | null;
    owner?: {
      id: string;
      first_name: string | null;
      last_name: string | null;
      display_name: string | null;
    } | null;
  } | null;
  onboarding_sessions?: OnboardingSession[];
}

interface OnboardingGridViewProps {
  items: OnboardingItem[];
  isLoading: boolean;
  onViewItem: (item: OnboardingItem) => void;
}

export const OnboardingGridView: React.FC<OnboardingGridViewProps> = ({
  items,
  isLoading,
  onViewItem,
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} className="h-48 rounded-lg" />
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center mb-4">
          <Package className="h-8 w-8 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium mb-2">Nenhum item encontrado</h3>
        <p className="text-muted-foreground">
          Não há itens de onboarding para exibir.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((item) => (
        <OnboardingCard
          key={item.id}
          item={item}
          onView={() => onViewItem(item)}
        />
      ))}
    </div>
  );
};
